import React from 'react';
import {useTranslation} from 'react-i18next';
import cssConstants from '../../constants/cssConstants';
import '../../static/css/modal.less';
import {useTscTheme} from '../../context/themeProvider';
import {IWorkerState} from '../../model/workerState';
import {StyledWarning} from '../util/StyledElements';
import {BasicModalPortal} from '../util/ModalPortalHelper';
import Constants from '../../constants/Constants';
import mediaApi from '../../service/mediaApi';
import {ControlButton, TscButtonType} from '@techsmith/tsc-cloud-style-guide';
import {IMediaViewDetails} from '../../model/mediaDetails';
import relativeTime from 'dayjs/plugin/relativeTime';
import dayjs from 'dayjs';

export const MediaInTrashModalBase: React.FC<IMediaInTrashModalProps> = ({mediaDetails, onClose}) => {
   const {t} = useTranslation();
   const theme = useTscTheme();
   const [modalState, setModalState] = React.useState<IWorkerState>({
      isWorking: false,
      hasError: false
   });
   dayjs.extend(relativeTime);
   const deletedOn = dayjs(mediaDetails.DeletedOn);
   const permanentDeletionDate = deletedOn.add(Constants.maxDaysForMediaInTrash, 'day');
   const today = dayjs();
   const daysTillPermanentDeletion = permanentDeletionDate.diff(today, 'day');

   const onGoToLibraryClick = () => {
      window.location.href = mediaDetails.TeamId ? `${Constants.navigation.teamsLink}/${mediaDetails.TeamId}` : Constants.navigation.myLibraryLink;
   };

   const onTakeOutTrashClick = async () => {
      setModalState({...modalState, isWorking: true});
      try {
         await mediaApi.restoreDeletedMedia([mediaDetails.Hash]);
         onClose();
         setModalState({...modalState, isWorking: false});
      } catch {
         setModalState({...modalState, hasError: true, isWorking: false});
      }
   };

   return (
      <BasicModalPortal
         testId="media-in-trash-modal"
         title={t('trash.mediaInTrashModal.title')}
         width={cssConstants.acceptTeamInvitationModalWidth}
         themeName={theme}
         isLoading={modalState.isWorking}
      >
         <div className="modal-body">
            <div className="form-body themeable-section">
               {modalState.hasError && (
                  <StyledWarning>
                     {t('general.errorText')}
                  </StyledWarning>
               )}
               <div className="form-field-group">
                  {t('trash.mediaInTrashModal.content', {title: mediaDetails.Title, daysTillDeletion: daysTillPermanentDeletion})}
               </div>

               <div className="form-field-group">
                  {t('trash.mediaInTrashModal.toAccessMedia')}
               </div>

               <div className="button-group">
                  <ControlButton
                     label={t('trash.mediaInTrashModal.toLibrary')}
                     buttonType={TscButtonType.secondary}
                     themeName={theme}
                     onClick={onGoToLibraryClick}
                     testId="go-to-library"
                  />

                  <ControlButton
                     label={t('trash.mediaInTrashModal.takeOutTrash')}
                     buttonType={TscButtonType.primary}
                     themeName={theme}
                     onClick={onTakeOutTrashClick}
                     testId="take-out-of-trash"
                  />
               </div>
            </div>

         </div>
      </BasicModalPortal>
   );
};

export interface IMediaInTrashModalProps {
   mediaDetails: IMediaViewDetails;
   onClose(): void;
}

export default MediaInTrashModalBase;
